import { PersonTypes } from '@frontend/api-person';
import { createShallowStore, createStoreWithSubscribe } from '@frontend/store';
import { CalendarEventsEnums } from '../views/Calendar/types';

type CalendarEventsFormTypeStoreType = {
  selectedForm: '' | CalendarEventsEnums;
  setSelectedForm: (value: '' | CalendarEventsEnums) => void;
  selectedPerson: null | PersonTypes.Person;
  setSelectedPerson: (value: null | PersonTypes.Person) => void;
};

const useCalendarEventsFormTypeStore = createStoreWithSubscribe<CalendarEventsFormTypeStoreType>(
  (set) => ({
    selectedForm: '',
    selectedPerson: null,
    setSelectedForm: (value) => set({ selectedForm: value }),
    setSelectedPerson: (value) => set({ selectedPerson: value }),
  }),
  {
    name: 'calendarEventsFormTypeStore',
  }
);

export const useCalendarEventsFormTypeShallowStore = createShallowStore(useCalendarEventsFormTypeStore);
